import Carousel from 'src/components/Carousel';
import {
  getSearchBreakPointsConfig,
  getThumbnailOptions
} from 'src/components/rails/railsHelper';
import ThumbnailComponent from 'src/components/thumbnail';
import { ThumbnailTypes } from 'src/components/thumbnail/types';
import { DynamicObject } from 'src/utils/commonTypes';
import { GenerateThumbnailObject } from 'src/utils/ConsumptionHelper/ConsumptionHelper';
import { ContentMetaData } from 'src/utils/ConsumptionHelper/types';
import { IMAGE_PATH_AND_NAME } from 'src/utils/ImageHelper/ImagePathHelper';
import { getImageURL } from 'src/utils/ImageHelper/ImageURLGenerator';
import {
  MixpanelRailTitle,
  MixpanelRailTypes,
  RailsMixpanelPayload
} from 'src/utils/railsMixpanelPayloadTypes';

import { useAppStore } from 'src/hooks/useAppStore';
import { getDeviceWidth } from '../../../utils/getDeviceWidth';
import * as customStyled from './SearchLandingStyle';

interface RenderSearchLandingProps {
  content: ContentMetaData;
  index: number;
}

export const RenderSearchLandingRails = (props: RenderSearchLandingProps) => {
  const { usersPreferenceData } = useAppStore();
  const { content, index } = props;

  const renderThumbnails = (
    thumbnails: DynamicObject,
    tagName: keyof typeof IMAGE_PATH_AND_NAME,
    verticalIndex: number,
    thumbnailTypes?: ThumbnailTypes,
    title?: string
  ) => {
    return thumbnails?.map((content: ContentMetaData, index: number) => {
      if (!Object.keys(content)?.length) return <></>;
      const generateThumbnailInstance: GenerateThumbnailObject =
        GenerateThumbnailObject.getThumbnailInstance(
          thumbnailTypes === ThumbnailTypes.horizontal
            ? ThumbnailTypes.horizontal
            : ThumbnailTypes.vertical,
          tagName,
          {
            content,
            hoverOut: true,
            displayTitleOnImage: false
          }
        );
      const generateThumbnailObject = generateThumbnailInstance.generate();
      const imageURL = getImageURL({
        tagName: generateThumbnailObject.tagName,
        deviceWidth: getDeviceWidth() || 0,
        item: {
          id: content.id,
          title: content.title,
          assetType: content.assetType,
          image: content.image
        }
      });

      const cardDetails = {
        contentId: content.id,
        title: title || '',
        horizontalIndex: index + 1,
        verticalIndex: verticalIndex + 1,
        modelName: content.modelName,
        assetSubtype: content.assetSubType,
        originalTitle: content.originalTitle
      };
      return (
        <ThumbnailComponent
          key={generateThumbnailObject.contentId}
          {...generateThumbnailObject}
          imageUrl={imageURL}
          cardDetails={cardDetails}
          showHover={true}
          isSearchLanding={true}
        />
      );
    });
  };

  const generateMixpanelPayload = (
    contents: DynamicObject,
    carouselTitle: string,
    verticalIndex: number
  ): RailsMixpanelPayload => {
    return {
      trayDetails: {
        allCollectionsResolved: false,
        index: verticalIndex,
        isEpisodeConsumption: false, // replace with thumbnailType
        isPendingResolved: true,
        isRecommendedColumn: false,
        pendingDataAvailable: false,
        title: MixpanelRailTitle.SEARCH_LANDING,
        tabName: '',
        talamoosModelName: '',
        type: MixpanelRailTypes.SIMILAR,
        carouselTitle
      },
      trayData: {
        content: contents?.map((content: DynamicObject) => ({
          title: content.title,
          value: content.title
        })),
        partnerDetails: {
          content_partner_id: usersPreferenceData?.partner
            ?.partner_id as number,
          content_partner_name: usersPreferenceData?.partner
            ?.partner_name as string
        }
      },
      activeSubscriptions: []
    };
  };

  const renderRails = (
    showTitle: boolean,
    contents: DynamicObject | undefined,
    tagName: keyof typeof IMAGE_PATH_AND_NAME,
    thumbnailTypes: ThumbnailTypes,
    title = '',
    verticalIndex: number
  ) => {
    return (
      <>
        {contents && Object.keys(contents)?.length ? (
          <div css={customStyled.railsContainer} key={verticalIndex}>
            {showTitle && (
              <div css={customStyled.railsHeaderStyle}>
                <h3 css={customStyled.railsTitle}>{title}</h3>
              </div>
            )}
            <Carousel
              isSearchLanding={true}
              mixpanelPayload={generateMixpanelPayload(
                contents,
                title,
                verticalIndex
              )}
              breakPointsConfig={getSearchBreakPointsConfig(thumbnailTypes)}>
              {renderThumbnails(
                contents,
                tagName,
                verticalIndex,
                thumbnailTypes,
                title
              )}
            </Carousel>
          </div>
        ) : null}
      </>
    );
  };

  return (
    <>
      {renderRails(
        true,
        content?.contents,
        ...getThumbnailOptions(content?.tags),
        content?.title,
        index
      )}
    </>
  );
};
